import { Phone, Ruler, FileText, Hammer, CheckCircle } from "lucide-react";

export const processSteps = [
  {
    number: "01",
    icon: Phone,
    title: "Консультация",
    description:
      "Бесплатная консультация по телефону. Обсуждаем ваши потребности и отвечаем на вопросы.",
  },
  {
    number: "02",
    icon: Ruler,
    title: "Замер",
    description:
      "Выезд специалиста на объект. Точные замеры и оценка объёма работ.",
  },
  {
    number: "03",
    icon: FileText,
    title: "Смета",
    description:
      "Подробная смета с фиксированной ценой. Никаких скрытых платежей.",
  },
  {
    number: "04",
    icon: Hammer,
    title: "Работа",
    description:
      "Выполнение работ по графику. Ежедневные фото-отчёты о ходе работ.",
  },
  {
    number: "05",
    icon: CheckCircle,
    title: "Приёмка",
    description: "Сдача объекта с гарантией. Проверяем качество вместе с вами.",
  },
] as const;
